import Box from "@mui/material/Box";

// Replaces the old .eyebrow Tailwind utility class.
export default function Eyebrow({ children, sx, ...props }) {
  return (
    <Box
      component="div"
      sx={{
        fontFamily: "'Outfit', sans-serif",
        textTransform: "uppercase",
        letterSpacing: "0.28em",
        fontSize: "0.7rem",
        fontWeight: 600,
        color: "primary.main",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
